// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KmxR","rootNoMargin":"styles_rootNoMargin__2Ttfy"};